exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pb4[data-v-3e648865] {\n  padding-bottom: 1.5em;\n}\n.flex-basis-2[data-v-3e648865] {\n  -ms-flex-preferred-size: 15%;\n      flex-basis: 15%;\n}\n@media screen and (min-width: 80em) {\n.dn-xl[data-v-3e648865] {\n  display: none;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e648865","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppFooter.vue
// module id = 1404
// module chunks = 0